import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Play24: FC<IconV2Props> = ({ icon, chroma, opacity, className }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`, className)}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={chroma === 'light' ? `${icon}-24` : `${icon}-24-solid`}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g className={chroma === 'light' ? s.darkStroke : null}>
        <g
          className={chroma === 'light' ? s.lightFill : s.darkFill}
          fillOpacity={opacity}
        >
          <g>
            <circle cx="12" cy="12" r="12" />
          </g>
        </g>
        <g
          className={chroma === 'light' ? s.darkFill : s.lightFill}
          fillRule="nonzero"
        >
          <g>
            <polygon
              transform="translate(13.000000, 12.250000) rotate(90.000000) translate(-13.000000, -12.250000) "
              points="13 9.25 16.75 15.25 9.25 15.25"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Play24;
